module.exports = __webpack_public_path__ + "static/media/zurichWhiteNew.1535521b.png";